/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsMortgageCreateMortgageLoanApplicationResponse {
    

    id?: string;

    leadNumber?: string;

    isTestLoan?: boolean;

    lastModified?: Date;

    downPayment?: number;

    loanAmount?: number;

    interestRate?: number;

    apr?: number;

    numberOfPayments?: number;

    dateOfFirstPayment?: Date;

    monthlyPayment?: number;

    loanClass?: LDCLPBPPublicApiModelsLoanApplicationsMortgageCreateMortgageLoanApplicationResponse.LoanClassEnum;

    loanClassOther?: string;

    county?: string;

    propertyAddress?: models.LDCLPBPPublicApiModelsCommonAddress;

    mailingAddress?: models.LDCLPBPPublicApiModelsCommonAddress;

    legalDescription?: string;

    yearBuilt?: number;

    units?: number;

    loanPurpose?: LDCLPBPPublicApiModelsLoanApplicationsMortgageCreateMortgageLoanApplicationResponse.LoanPurposeEnum;

    loanPurposeOther?: string;

    purchasePrice?: number;

    appraisedValue?: number;

    lotYearAcquired?: number;

    lotOriginalCost?: number;

    lotExistingLiens?: number;

    lotPresentValue?: number;

    lotImprovementCost?: number;

    yearAcquired?: number;

    originalCost?: number;

    existingLiens?: number;

    refiPurpose?: LDCLPBPPublicApiModelsLoanApplicationsMortgageCreateMortgageLoanApplicationResponse.RefiPurposeEnum;

    improvementsMade?: boolean;

    improvementsProposed?: boolean;

    improvementsDescription?: string;

    improvementsCost?: number;

    primaryBorrowerId?: string;

    borrowers?: Array<models.LDCLPBPPublicApiModelsBorrowersMortgageBorrower>;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsMortgageCreateMortgageLoanApplicationResponse {

    export enum LoanClassEnum { 
        Unknown = <any> 'Unknown',
        Conventional = <any> 'Conventional',
        FHA = <any> 'FHA',
        VA = <any> 'VA',
        USDA = <any> 'USDA',
        Others = <any> 'Others',
    }

    export enum LoanPurposeEnum { 
        Purchase = <any> 'Purchase',
        RateTermRefinance = <any> 'RateTermRefinance',
        CashOutRefinance = <any> 'CashOutRefinance',
        StreamlineRefi = <any> 'StreamlineRefi',
        Unspecified = <any> 'Unspecified',
        HELOC = <any> 'HELOC',
        HELOCPurchase = <any> 'HELOCPurchase',
    }

    export enum RefiPurposeEnum { 
        Unknown = <any> 'Unknown',
        CashOutDebtConsolidation = <any> 'CashOutDebtConsolidation',
        CashOutHomeImprovement = <any> 'CashOutHomeImprovement',
        CashOutLimited = <any> 'CashOutLimited',
        CashOutOther = <any> 'CashOutOther',
        NoCashOutFHAStreamlined = <any> 'NoCashOutFHAStreamlined',
        NoCashOutFREOwned = <any> 'NoCashOutFREOwned',
        NoCashOutOther = <any> 'NoCashOutOther',
        NoCashOutStreamlined = <any> 'NoCashOutStreamlined',
        ChangeInRateTerm = <any> 'ChangeInRateTerm',
        PortfolioRetentionStreamlined = <any> 'PortfolioRetentionStreamlined',
    }
}
